import {
  checkExperimentBase,
  type ExperimentChecker,
} from "./ExperimentChecker";
import { fluentExperiments } from "./fluentExperiments";

let v9ButtonEnabled: boolean = false;
let v9CompoundButtonEnabled: boolean = false;
let v9CheckboxEnabled: boolean = false;
let v9PaddlesInkButtonsEnabled: boolean = false;

export const setV9ButtonEnabled = (isEnabled: boolean) => {
  v9ButtonEnabled = isEnabled;
};

export function isV9ButtonEnabled(
  isExperimentalFeatureEnabled?: (feature: string) => boolean
): boolean {
  return (
    v9ButtonEnabled ||
    !!isExperimentalFeatureEnabled?.(fluentExperiments.fluentV9ButtonIsEnabled)
  );
}

export const setV9CompoundButtonEnabled = (isEnabled: boolean) => {
  v9CompoundButtonEnabled = isEnabled;
};

export function isV9CompoundButtonEnabled(
  isExperimentalFeatureEnabled?: (feature: string) => boolean
): boolean {
  return (
    v9CompoundButtonEnabled ||
    !!isExperimentalFeatureEnabled?.(
      fluentExperiments.fluentV9CompoundButtonIsEnabled
    )
  );
}

export const setV9CheckboxEnabled = (isEnabled: boolean) => {
  v9CheckboxEnabled = isEnabled;
};

export function isV9CheckboxEnabled(
  isExperimentalFeatureEnabled?: (feature: string) => boolean
): boolean {
  return (
    v9CheckboxEnabled ||
    !!isExperimentalFeatureEnabled?.(
      fluentExperiments.fluentV9CheckboxIsEnabled
    )
  );
}

export const setV9PaddlesInkButtonsEnabled = (isEnabled: boolean) => {
  v9PaddlesInkButtonsEnabled = isEnabled;
};

export function isV9RibbonButtonEnabled(
  appContext: ExperimentChecker
): boolean {
  return (
    v9PaddlesInkButtonsEnabled ||
    !!checkExperimentBase(
      appContext,
      fluentExperiments.fluentV9RibbonButtonIsEnabled
    )
  );
}
